const Menu = [
  {
    title: '首页',
    group: 'apps',
    icon: 'home',
    name: 'Home'
  },
  {
    title: '生产管理',
    group: 'apps',
    icon: 'fa-cogs',
    name: 'ProduceMng',
    access: ['admin', 'producemng']
  },
  {
    title: '仓储笼',
    group: 'cage',
    icon: 'storage',
    access: ['admin', 'cage'],
    items: [
      {
        title: '仓储笼管理',
        icon: 'storage',
        name: 'CageMng',
        access: ['admin', 'cage']
      },
      {
        title: '仓储笼历史',
        icon: 'dvr',
        name: 'CageHis',
        access: ['admin', 'cage']
      }
    ]
  },
  {
    title: '出库管理',
    group: 'apps',
    icon: 'all_out',
    name: 'StockOutMng',
    access: ['admin', 'stockout']
  },
  { header: '系统设置' },
  {
    title: '客户管理',
    group: 'apps',
    icon: 'domain',
    name: 'CustomerMng',
    access: ['admin', 'customer']
  },
  {
    title: '釜票管理',
    group: 'apps',
    icon: 'memory',
    name: 'FormulaMng',
    access: ['admin', 'formula']
  },
  {
    title: '用户管理',
    group: 'apps',
    icon: 'people',
    name: 'UserMng',
    access: ['admin']
  }
]

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase()
      let textB = y.title.toUpperCase()
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
  }
})

export default Menu
